import { render, staticRenderFns } from "./QualificationsPerson.vue?vue&type=template&id=7b75467f"
import script from "./QualificationsPerson.vue?vue&type=script&lang=js"
export * from "./QualificationsPerson.vue?vue&type=script&lang=js"
import style0 from "./QualificationsPerson.vue?vue&type=style&index=0&id=7b75467f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports